<template>
    <div class="row-table total-sum">
        <template v-if="isEmployerManager">
            <div class="table-cell text-center">
                {{ dealsTotalCount }}
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                {{ formatFinance(dealsSquareM2Sum.toFixed(2)) }}
            </div>
            <div class="table-cell nowrap">
                {{ formatFinance(dealsSumSum) }}
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                {{ dealsBonus1PercentSum }}
            </div>
            <div class="table-cell text-center">
                {{ dealBonusSum }}
            </div>
            <div class="table-cell text-center">
                {{ dealFineSum }}
            </div>
            <div class="table-cell text-center">
                {{ dealJalousieSum }}
            </div>
            <div class="table-cell text-center">
                {{ dealFinishSum }}
            </div>
            <template v-if="hasExpenseComplaintDeals">
                <div>
                    {{ formatFinance(dealCompaintMaterialsSum) }}
                </div>
                <div>
                    {{ formatFinance(dealComplaintWorkSum) }}
                </div>
            </template>
            <div class="table-cell">
                {{ dealsTotalSumAccrued ? formatFinance(dealsTotalSumAccrued) : 0 }}
            </div>
            <div class="table-cell">
                {{ dealsTotalSumPaid ? formatFinance(dealsTotalSumPaid) : 0 }}
            </div>
            <div class="table-cell">
                {{ dealsTotalSumResidue ? formatFinance(dealsTotalSumResidue) : 0 }}
            </div>
        </template>
        <template v-else-if="isEmployerMeasurer">
            <div class="table-cell text-center">
                {{ dealsTotalCount }}
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                {{ formatFinance(dealsSquareM2Sum.toFixed(2)) }}
            </div>
            <div class="table-cell nowrap">
                {{ formatFinance(dealsSumSum) }}
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                {{ dealsBonus1PercentSum }}
            </div>
            <div class="table-cell">
                {{ dealBonusMeasurerSum }}
            </div>
            <div class="table-cell text-center">
                {{ dealBonusSum }}
            </div>
            <div class="table-cell text-center">
                {{ dealFineSum }}
            </div>
            <div class="table-cell">
                {{ dealJalousieSum }}
            </div>
            <div class="table-cell">
                {{ dealFinishSum }}
            </div>
            <template v-if="hasExpenseComplaintDeals">
                <div>
                    {{ formatFinance(dealCompaintMaterialsSum) }}
                </div>
                <div>
                    {{ formatFinance(dealComplaintWorkSum) }}
                </div>
            </template>
            <div class="table-cell">
                {{ dealsTotalSumAccrued ? formatFinance(dealsTotalSumAccrued) : 0 }}
            </div>
            <div class="table-cell">
                {{ dealsTotalSumPaid ? formatFinance(dealsTotalSumPaid) : 0 }}
            </div>
            <div class="table-cell">
                {{ dealsTotalSumResidue ? formatFinance(dealsTotalSumResidue) : 0 }}
            </div>
        </template>
        <template v-else>
            <div class="table-cell text-center">
                {{ dealsTotalCount }}
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                &nbsp;
            </div>
            <div class="table-cell">
                {{ formatFinance(dealsSquareM2Sum.toFixed(2)) }}
            </div>
            <div class="table-cell nowrap">
                {{ formatFinance(dealsSumSum) }}
            </div>
            <template v-if="hasExpenseComplaintDeals">
                <div>
                    {{ formatFinance(dealCompaintMaterialsSum) }}
                </div>
                <div>
                    {{ formatFinance(dealComplaintWorkSum) }}
                </div>
            </template>
            <div class="table-cell">
                {{ dealsTotalSumAccrued ? formatFinance(dealsTotalSumAccrued) : 0 }}
            </div>
            <div class="table-cell">
                {{ dealsTotalSumPaid ? formatFinance(dealsTotalSumPaid) : 0 }}
            </div>
            <div class="table-cell">
                {{ dealsTotalSumResidue ? formatFinance(dealsTotalSumResidue) : 0 }}
            </div>
        </template>
    </div>
</template>

<script>
import localReferences from '@/helpers/localReferences';
import '@/assets/styles/expenses.scss';
import { formatFinance } from '@/common/utilities';

export default {
    name: 'PayrollInfoEmployerDealTotal',
    props: {
        deals: {
            type: Array,
            default: () => {}
        },
        employerPositionId: {
            type: Number,
            default: 0
        },
        hasExpenseComplaintDeals: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
        };
    },
    computed: {
        isEmployerManager() {
            if (this.employerPositionId === localReferences.employerPositions.manager) {
                return true;
            }
            return false;
        },
        isEmployerMeasurer() {
            if (this.employerPositionId === localReferences.employerPositions.measurer) {
                return true;
            }
            return false;
        },
        dealsTotalCount() {
            return this.deals.reduce((sum, deal) => sum + 1, 0);
        },
        dealsSquareM2Sum() {
            return this.deals.reduce((sum, deal) => sum + +deal.square_m2, 0);
        },
        dealsSumSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.sum, 0);
        },
        dealsBonus1PercentSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.bonus_1_percent.accrued, 0);
        },
        dealBonusMeasurerSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.bonus_measurer.accrued, 0);
        },
        dealBonusSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.bonus_deal.accrued, 0);
        },
        dealFineSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.fine_deal.accrued, 0);
        },
        dealJalousieSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.jalousie.accrued, 0);
        },
        dealFinishSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.finish.accrued, 0);
        },
        dealCompaintMaterialsSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.complaint_materials.accrued, 0);
        },
        dealComplaintWorkSum() {
            return this.deals.reduce((sum, deal) => sum + +deal.complaint_work.accrued, 0);
        },
        dealsTotalSumAccrued() {
            return this.$store.state.salary.dealsTotalSum.accrued;
        },
        dealsTotalSumPaid() {
            return this.$store.state.salary.dealsTotalSum.paid;
        },
        dealsTotalSumResidue() {
            return this.$store.state.salary.dealsTotalSum.residue;
        }
    },
    methods: {
        formatFinance
    }
};
</script>
